import React from 'react';
import { motion } from 'framer-motion';
import { OPENFINANCE_THEME } from '../../constants/openFinanceTheme';
import { BoxIcon } from 'lucide-react';
export interface NavTab {
  id: string;
  label: string;
  icon: BoxIcon;
  badge?: number;
}
interface SidebarProps {
  tabs: NavTab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
}
export function Sidebar({
  tabs,
  activeTab,
  onTabChange
}: SidebarProps) {
  return <nav className="hidden md:flex flex-col w-64 h-screen bg-white border-r-2 fixed left-0 top-0 z-40" style={{
    borderColor: OPENFINANCE_THEME.colors.borderLight
  }} data-id="element-1712">
      {/* Logo */}
      <div className="p-6 border-b-2" style={{
      borderColor: OPENFINANCE_THEME.colors.borderLight
    }} data-id="element-1713">
        <div className="flex items-center gap-3" data-id="element-1714">
          <div className="w-10 h-10 rounded-xl flex items-center justify-center p-2" style={{
          background: `linear-gradient(135deg, ${OPENFINANCE_THEME.colors.primary500} 0%, ${OPENFINANCE_THEME.colors.primary600} 100%)`
        }} data-id="element-1715">
            <img src="https://cdn.magicpatterns.com/uploads/6ixnVN3mm3sFs3kb5m4Wow/apple-touch-icon.png" alt="VeloX" className="w-full h-full object-contain" data-id="element-1716" />
          </div>
          <div data-id="element-1717">
            <div className="text-lg font-bold" style={{
            color: OPENFINANCE_THEME.colors.text,
            fontFamily: OPENFINANCE_THEME.fonts.heading
          }} data-id="element-1718">
              VeloX
            </div>
            <div className="text-xs" style={{
            color: OPENFINANCE_THEME.colors.textMuted
          }} data-id="element-1719">
              Personal Finance
            </div>
          </div>
        </div>
      </div>

      {/* Navigation Items */}
      <div className="flex-1 p-4 space-y-1" data-id="element-1720">
        {tabs.map(tab => {
        const Icon = tab.icon;
        const isActive = activeTab === tab.id;
        return <button key={tab.id} onClick={() => onTabChange(tab.id)} className="relative w-full flex items-center gap-3 px-4 py-3 rounded-xl transition-all" style={{
          backgroundColor: isActive ? OPENFINANCE_THEME.colors.primary500 + '10' : 'transparent',
          color: isActive ? OPENFINANCE_THEME.colors.primary500 : OPENFINANCE_THEME.colors.textMuted
        }} data-id="element-1721">
              {/* Active Indicator */}
              {isActive && <motion.div layoutId="activeSidebarTab" className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-8 rounded-r-full" style={{
            backgroundColor: OPENFINANCE_THEME.colors.primary500
          }} transition={{
            type: 'spring',
            stiffness: 500,
            damping: 30
          }} data-id="element-1722" />}

              {/* Icon */}
              <div className="relative" data-id="element-1723">
                <Icon className="w-5 h-5" strokeWidth={isActive ? 2.5 : 2} data-id="element-1724" />

                {/* Badge */}
                {tab.badge !== undefined && tab.badge > 0 && <motion.div initial={{
              scale: 0
            }} animate={{
              scale: 1
            }} className="absolute -top-1 -right-1 min-w-[16px] h-[16px] rounded-full flex items-center justify-center text-[9px] font-bold text-white px-1" style={{
              backgroundColor: OPENFINANCE_THEME.colors.error
            }} data-id="element-1725">
                    {tab.badge > 9 ? '9+' : tab.badge}
                  </motion.div>}
              </div>

              {/* Label */}
              <span className="text-sm font-medium" style={{
            fontFamily: OPENFINANCE_THEME.fonts.body,
            fontWeight: isActive ? 600 : 500
          }} data-id="element-1726">
                {tab.label}
              </span>
            </button>;
      })}
      </div>

      {/* Footer */}
      <div className="p-4 border-t-2" style={{
      borderColor: OPENFINANCE_THEME.colors.borderLight
    }} data-id="element-1727">
        <div className="text-xs text-center" style={{
        color: OPENFINANCE_THEME.colors.textMuted
      }} data-id="element-1728">
          Powered by Open Finance
        </div>
      </div>
    </nav>;
}